import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PagedList } from "../../../app/model/domain/PagedList";
import { environment } from "../../../environments/environment";
import { Exchange } from "../../model/domain/Exchange";
import { FilterDateType } from "./../../model/domain/MonitorFilter";
import { ITicketableService, StatusDetails } from "./ITicketableService";

@Injectable({
  providedIn: "root",
})
export class ExchangeService implements ITicketableService<Exchange> {
  private readonly name = "exchange";

  constructor(private http: HttpClient) {}

  registerTicket(ticket: Exchange) {
    return this.http.post(
      `${environment.apiUrls.tickets}/${this.name}/`,
      ticket
    );
  }

  updateTicket(id: number, ticket: Exchange) {
    return this.http.put(
      `${environment.apiUrls.tickets}/${this.name}/${id}`,
      ticket
    );
  }

  getTicket(id: number) {
    return this.http.get<Exchange>(
      `${environment.apiUrls.tickets}/${this.name}/${id}`
    );
  }

  listTicket(
    dateType: FilterDateType = null,
    startDate: Date = null,
    endDate: Date = null,
    statusId: number = null,
    operationTypeId: number = null,
    settlementTypeId: number = null,
    portfolioCode: string = null,
    portfolioName: string = null,
    portfolioDocument: string = null,
    ticketId: number = null,
    accountManagerId: number = null,
    page: number = null,
    pageSize: number = null,
    isOutstanding: boolean = false
  ) {
    const params: any = { isOutstanding: isOutstanding };

    if (dateType) {
      params.dateType = dateType;
    }

    if (startDate) {
      params.startDate = startDate.toJSON();
    }

    if (endDate) {
      params.endDate = endDate.toJSON();
    }

    if (statusId) {
      params.statusId = statusId.toString();
    }

    if (operationTypeId) {
      params.operationTypeId = operationTypeId;
    }

    if (settlementTypeId) {
      params.settlementTypeId = settlementTypeId;
    }

    if (portfolioCode) {
      params.portfolioCode = portfolioCode;
    }

    if (portfolioName) {
      params.portfolioName = portfolioName;
    }

    if (portfolioDocument) {
      params.portfolioDocument = portfolioDocument;
    }

    if (ticketId) {
      params.ticketId = ticketId;
    }

    if (accountManagerId) {
      params.accountManagerId = accountManagerId;
    }

    if (page) {
      params.page = page;
    }

    if (pageSize) {
      params.pageSize = pageSize;
    }

    return this.http.get<PagedList<Exchange>>(
      `${environment.apiUrls.tickets}/${this.name}/list-paginated`,
      {
        params,
      }
    );
  }

  forwardTicket(id: number) {
    return this.http.post<StatusDetails>(
      `${environment.apiUrls.tickets}/${this.name}/${id}/forward`,
      {}
    );
  }

  cancelDraftTicket(id: number) {
    return this.http.post<StatusDetails>(
      `${environment.apiUrls.tickets}/${this.name}/${id}/cancel`,
      {}
    );
  }
}
